
import 'select2'; // globally assign select2 fn to $ element

export default {
  init() {
    // multiple select with AJAX search
    jQuery('#pomelo_select2_keywords').select2({
      tags: true,
      placeholder: window.PomeloVar.search,
      dropdownAutoWidth: false,
      width: '100%',
    });
    jQuery('#taxo-auteur').select2({
      dropdownAutoWidth: false,
      width: '100%',
    });
    jQuery('#taxo-revues').select2({
      dropdownAutoWidth: false,
      width: '100%',
    });
    jQuery('.row-bibliotheque form').find('select, input').on('change', function(){
      jQuery('.row-bibliotheque form').submit();
    });
    jQuery('.author-link').find('a').on('click', function(e) {
      e.preventDefault();
      var authorSlug = $(this).data('slug');
      jQuery('.row-bibliotheque form').find('#taxo-auteur option[value="' + authorSlug + '"]').prop('selected', true).trigger('change');
    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/template-bibliotheque.js